import React, { useState } from "react";
import "./Generate_Report_form.css";
import { Button, Form, Nav, Tab } from "react-bootstrap";
import Certification_Modal from "../../../../../../../common/common_modal/certification_modal/Certification_Modal";

function Generate_Report_form() {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <section className="Legal_Entity_Form Generate_Report_form">
        <div className="white_container customer_section">
          {/* ================= DETAILS OF INSTRUMENT USED ================= */}

          <div className="tables_tab_section">
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey="Personnel_Report"
            >
              <Nav variant="pills" className="">
                <div className="note_text_holder">
                  <p className="red_text mb-0">
                    Select Room For Generate Report:
                  </p>
                </div>
                <Nav.Item>
                  <Nav.Link eventKey="Personnel_Report">
                    Personnel Report
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="Furnace_Room">Furnace Room</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="Room_3">Room 3</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="Room_4">Room 4</Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content className="inner-tab-sec">
                <Tab.Pane eventKey="Personnel_Report">
                  <Form.Group className="form_group">
                    <Form.Label>Generate Report:</Form.Label>
                  </Form.Group>

                  <div className="row">
                    {/* Lab Room */}
                    <div className="col-md-4">
                      <Form.Group className="form_group ">
                        <Form.Control placeholder="Date From : DD/MM/YYYY" />
                      </Form.Group>
                    </div>
                    <div className="col-md-4">
                      <Form.Group className="form_group ">
                        <Form.Control placeholder="Date To : DD/MM/YYYY" />
                      </Form.Group>
                    </div>
                  </div>

                  {/* ================= ACTION BUTTONS ================= */}
                  <div className="permission_btn_holder mt-4">
                    <Button className="permission_btn Yes_btn" onClick={() => setShowModal(true)}>
                      Generate Report
                    </Button>
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="Furnace_Room">
                  <Form.Group className="form_group">
                    <Form.Label>Generate Report:</Form.Label>
                  </Form.Group>

                  <div className="row">
                    {/* Lab Room */}
                    <div className="col-md-4">
                      <Form.Group className="form_group ">
                        <Form.Control placeholder="Date From : DD/MM/YYYY" />
                      </Form.Group>
                    </div>
                    <div className="col-md-4">
                      <Form.Group className="form_group ">
                        <Form.Control placeholder="Date To : DD/MM/YYYY" />
                      </Form.Group>
                    </div>
                  </div>

                  {/* ================= ACTION BUTTONS ================= */}
                  <div className="permission_btn_holder mt-4">
                    <Button className="permission_btn Yes_btn" onClick={() => setShowModal(true)}> 
                      Generate Report
                    </Button>
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="Room_3">
                  <Form.Group className="form_group">
                    <Form.Label>Generate Report:</Form.Label>
                  </Form.Group>

                  <div className="row">
                    {/* Lab Room */}
                    <div className="col-md-4">
                      <Form.Group className="form_group ">
                        <Form.Control placeholder="Date From : DD/MM/YYYY" />
                      </Form.Group>
                    </div>
                    <div className="col-md-4">
                      <Form.Group className="form_group ">
                        <Form.Control placeholder="Date To : DD/MM/YYYY" />
                      </Form.Group>
                    </div>
                  </div>

                  {/* ================= ACTION BUTTONS ================= */}
                  <div className="permission_btn_holder mt-4">
                    <Button className="permission_btn Yes_btn" onClick={() => setShowModal(true)}>
                      Generate Report
                    </Button>
                  </div>
                </Tab.Pane>

                <Tab.Pane eventKey="Room_4">
                  <Form.Group className="form_group">
                    <Form.Label>Generate Report:</Form.Label>
                  </Form.Group>

                  <div className="row">
                    {/* Lab Room */}
                    <div className="col-md-4">
                      <Form.Group className="form_group ">
                        <Form.Control placeholder="Date From : DD/MM/YYYY" />
                      </Form.Group>
                    </div>
                    <div className="col-md-4">
                      <Form.Group className="form_group ">
                        <Form.Control placeholder="Date To : DD/MM/YYYY" />
                      </Form.Group>
                    </div>
                  </div>
                  {/* ================= ACTION BUTTONS ================= */}
                  <div className="permission_btn_holder mt-4">
                    <Button className="permission_btn Yes_btn"     onClick={() => setShowModal(true)}>
                      Generate Report
                    </Button>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </section>
      <Certification_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        modalHeadingText={"Generate Lab Room Report"}
        imgSrc={"/assets/images/cerificate/certi.png"}
        btnText={"Download"}
      />
    </>
  );
}

export default Generate_Report_form;
